import type { EventGroup } from "../../types/swagger";
import { mockMemberNames } from "./members";

export interface MockSeasonEventResult {
  name: string;
  point: number;
  singlesRank: number;
}

export interface MockSeasonEvent {
  id: string;
  event_group: EventGroup;
  joined_flg: boolean;
  title: string;
  datetime: string;
  place: string;
  singles_flag: boolean;
  singles_point_flag: boolean;
  singles_ex_point_flag: boolean;
  doubles_flag: boolean;
  doubles_point_flag: boolean;
  match_format: string;
  participation_fee: string;
  other: string;
  participation_start_datetime: string;
  tournament_created_flg: boolean;
  tournament_started_flg: boolean;
  event_ended_flg: boolean;
  singles_ranking_points: Array<{ rank: number; point: number }>;
  doubles_ranking_points: Array<{ rank: number; point: number }>;
  participants: string[];
  results: MockSeasonEventResult[];
}

export const rankingEventGroup: EventGroup = {
  id: "1",
  name: "Soft Darts TL 2026",
};

export const loginMemberProfile = {
  login_id: "akira_menai",
  dartslive_card_name: "Akira menai",
  name: "Akira menai",
};

const rankingParticipants = Object.values(mockMemberNames);

const createSeasonEvent = (
  overrides: Partial<MockSeasonEvent> &
    Pick<MockSeasonEvent, "id" | "title" | "datetime">,
): MockSeasonEvent => ({
  event_group: rankingEventGroup,
  joined_flg: false,
  place: "ヒーローズカフェ",
  singles_flag: true,
  singles_point_flag: true,
  singles_ex_point_flag: false,
  doubles_flag: false,
  doubles_point_flag: false,
  match_format: "501-501-Cricket",
  participation_fee: "2,000",
  other: "ローカル検証用モック",
  participation_start_datetime: overrides.datetime,
  tournament_created_flg: false,
  tournament_started_flg: false,
  event_ended_flg: false,
  singles_ranking_points: [],
  doubles_ranking_points: [],
  participants: rankingParticipants,
  results: [],
  ...overrides,
});

export const buildMockEventName = (
  event: Pick<MockSeasonEvent, "title">,
): string => event.title;

export const mockSeasonEvents: MockSeasonEvent[] = [
  createSeasonEvent({
    id: "3f5f6f72-a11c-4c1b-9f15-cfa6311e51a1",
    title: "Autumn Opening",
    datetime: "2025-11-16T05:00:00.000Z",
    event_ended_flg: true,
    results: [
      { name: "Sho Aoki", point: 150, singlesRank: 1 },
      { name: "Akira menai", point: 120, singlesRank: 2 },
      { name: "野澤 哲也", point: 90, singlesRank: 3 },
      { name: "Max Verstappen", point: 60, singlesRank: 5 },
    ],
  }),
  createSeasonEvent({
    id: "31d7520c-5788-4b85-b7a8-a6d7d644de01",
    title: "Winter Masters",
    datetime: "2025-12-14T05:00:00.000Z",
    event_ended_flg: true,
    results: [
      { name: "Sho Aoki", point: 180, singlesRank: 1 },
      { name: "Akira menai", point: 150, singlesRank: 2 },
      { name: "野澤 哲也", point: 120, singlesRank: 3 },
      { name: "Max Verstappen", point: 90, singlesRank: 5 },
    ],
  }),
  createSeasonEvent({
    id: "d7e2c48f-3bc6-4f90-9b51-a4bc0376f5d6",
    title: "New Year Cup",
    datetime: "2026-01-18T05:00:00.000Z",
    event_ended_flg: true,
    results: [
      { name: "Sho Aoki", point: 210, singlesRank: 1 },
      { name: "Akira menai", point: 150, singlesRank: 2 },
      { name: "野澤 哲也", point: 150, singlesRank: 3 },
      { name: "Max Verstappen", point: 90, singlesRank: 5 },
    ],
  }),
  createSeasonEvent({
    id: "74ea7389-c0ff-4857-8ca8-f94cc961e7a7",
    title: "February Challenge",
    datetime: "2026-02-15T05:00:00.000Z",
    event_ended_flg: true,
    results: [
      { name: "Sho Aoki", point: 150, singlesRank: 2 },
      { name: "Akira menai", point: 180, singlesRank: 1 },
      { name: "野澤 哲也", point: 120, singlesRank: 3 },
      { name: "Max Verstappen", point: 90, singlesRank: 5 },
    ],
  }),
  createSeasonEvent({
    id: "4d76a4c1-cf13-4c86-9df9-2da59ab4d8dc",
    title: "Spring Challenge",
    datetime: "2026-03-18T11:00:00.000Z",
    event_ended_flg: true,
    results: [
      { name: "Sho Aoki", point: 210, singlesRank: 1 },
      { name: "Akira menai", point: 150, singlesRank: 2 },
      { name: "野澤 哲也", point: 120, singlesRank: 3 },
      { name: "Max Verstappen", point: 90, singlesRank: 5 },
    ],
  }),
  createSeasonEvent({
    id: "fd7909b0-c0fc-44f8-816e-77d20e5a3ddf",
    title: "Stage999",
    datetime: "2026-04-04T08:00:00.000Z",
    joined_flg: true,
    singles_ex_point_flag: true,
    tournament_created_flg: true,
    event_ended_flg: true,
    other: "ランキング反映済みの最新ステージ",
    results: [
      { name: "Sho Aoki", point: 240, singlesRank: 1 },
      { name: "Akira menai", point: 180, singlesRank: 2 },
      { name: "野澤 哲也", point: 150, singlesRank: 3 },
      { name: "Max Verstappen", point: 120, singlesRank: 4 },
    ],
  }),
  createSeasonEvent({
    id: "1f2e3d4c-5b6a-7980-1234-abcdef987654",
    title: "Stage888",
    datetime: "2026-05-10T08:00:00.000Z",
    joined_flg: true,
    tournament_created_flg: true,
    other: "16名予定のトーナメント",
  }),
  createSeasonEvent({
    id: "516d5f20-d9d8-4d75-89b1-2954bc1f2d95",
    title: "Summer Warmup",
    datetime: "2026-06-14T07:00:00.000Z",
    place: "ダーツバー Meteor",
    participation_fee: "2,500",
    other: "通常トーナメント前の調整イベント",
  }),
];
